import { render, staticRenderFns } from "./SpecialOfferTrialAdsPage.vue?vue&type=template&id=1d9a579c&scoped=true"
import script from "./SpecialOfferTrialAdsPage.vue?vue&type=script&lang=ts"
export * from "./SpecialOfferTrialAdsPage.vue?vue&type=script&lang=ts"
import style0 from "./SpecialOfferTrialAdsPage.vue?vue&type=style&index=0&id=1d9a579c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a579c",
  null
  
)

export default component.exports